<script>
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'

import EmployeeResource from '../resources/employee'

export default Vue.extend({
    components: {
        AgGridVue,
    },
    props: {
        rowData: {
            required: false,
            type: Array,
            default: () => {
                return []
            },
        },
    },
    data() {
        return {
            employeesColumnDefs: [
                {
                    field: 'id',
                    headerName: 'ID#',
                    sortable: true,
                    valueSetter: () => null,
                    valueGetter: (params) => {
                        return params.data.attributes.id
                    },
                },
                {
                    field: 'tin',
                    headerName: 'SSN',
                    sortable: true,
                    valueSetter: () => null,
                    valueGetter: (params) => {
                        return params.data.attributes.tin
                    },
                },
                {
                    field: 'password',
                    headerName: 'Password',
                    sortable: true,
                    valueGetter: (params) => {
                        if (params.data.attributes.password) return true
                        else return false
                    },
                },
                {
                    field: 'hash',
                    headerName: 'Hash',
                    sortable: true,
                    valueGetter: (params) => {
                        return params.data.attributes.hash
                    },
                },
                {
                    field: 'last_name',
                    headerName: 'Last Name',
                    sortable: true,
                    valueGetter: (params) => {
                        return params.data.attributes.last_name
                    },
                },
                {
                    field: 'first_name',
                    headerName: 'First Name',
                    sortable: true,
                    valueGetter: (params) => {
                        return params.data.attributes.first_name
                    },
                },
                {
                    field: 'birth_date',
                    headerName: 'Birth Date',
                    sortable: true,
                    valueGetter: (params) => {
                        return params.data.attributes.birth_date
                    },
                },
                {
                    field: 'email',
                    headerName: 'E-mail',
                    sortable: true,
                    valueGetter: (params) => {
                        return params.data.attributes.email
                    },
                },
                {
                    field: 'status',
                    headerName: 'Status',
                    sortable: true,
                    valueGetter: (params) => {
                        if (params.data.attributes.status) return 'Active'
                        else return 'InActive'
                    },
                },
                {
                    field: 'main_state_id',
                    headerName: 'Permanent Resident State',
                    sortable: true,
                    valueGetter: (params) => {
                        return params.data.get('main_state_id.name')
                    },
                },
            ],
        }
    },
    computed: {
        resources() {
            return {
                EmployeeResource,
            }
        },
    },
    methods: {
        onGridReady(params) {
            this.gridApi = params.api
            this.columnApi = params.columnApi
        },

        selectEmployee(params) {
            if (params && params.data && params.data.attributes) this.$emit('select', params.data)
        },
    },
})
</script>

<template>
    <div>
        <h4>Shows Employees Grid</h4>
        <ag-grid-vue class="ag-theme-balham default-grid" :column-defs="employeesColumnDefs" :row-data="rowData" @grid-ready="onGridReady" @row-clicked="selectEmployee" />
    </div>
</template>

<style>
@import '../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
@import '../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css';

.default-grid {
    width: 100%;
    height: 200px;
}
</style>
